import * as D from '../../def';
export const annotation:D.IAnnotation = {
  circle: {
    pricePoints: [
      {
        color: 'green',
        date: {
          year: 2018,
          month: 12,
          day: 8,
        },
      },
      {
        color: 'red',
        date: {
          year: 2019,
          month: 6,
          day: 27,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 3,
          day: 17,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 2,
          day: 19,
        },
      },
    ],
    IndicePoints: [
      {
        color: 'green',
        date: {
          year: 2018,
          month: 12,
          day: 8,
        },
      },
      {
        color: 'red',
        date: {
          year: 2019,
          month: 6,
          day: 27,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 3,
          day: 23,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 2,
          day: 19,
        },
      },
    ],
  },
};
